import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.1 7c-.844-.965-1.913-1.617-3.074-1.876a5.2 5.2 0 0 0-3.45.423c-1.089.534-2.019 1.43-2.672 2.579A7.86 7.86 0 0 0 7.9 12c0 1.378.349 2.726 1.003 3.874s1.583 2.045 2.672 2.58c1.09.533 2.29.68 3.45.422s2.23-.911 3.074-1.876m-4.2-7h-8m0 4h8"
    />
  </svg>
);
export default SvgCurrencyEuro;
